import { put, select } from 'redux-saga/effects'
import { type NamedEntity, Utils } from '@pbt/pbt-ui-components'

import { updateNotificationsLinkedToAreaListItem } from '../../actions/notifications'
import { getNotificationArea } from '../../reducers/constants'

export function* updateNotificationsAndTotalCountsForArea({
  notificatedEntities = {},
  unreadNotificationsTotalCount = 0,
  notificationAreaName,
}: {
  notificatedEntities: any
  notificationAreaName: string
  unreadNotificationsTotalCount?: number
}): Generator {
  const NotificationAreas = yield select(getNotificationArea)
  const areaId = Utils.findConstantIdByName(
    notificationAreaName,
    NotificationAreas as NamedEntity[],
  )

  const notificationIdsByLinkedItemId: Record<string, string[]> =
    Object.fromEntries(
      Object.values(notificatedEntities).map((entity) => [
        // @ts-ignore
        entity.id,
        // @ts-ignore
        entity.notifications,
      ]),
    )

  yield put(
    updateNotificationsLinkedToAreaListItem(
      notificationIdsByLinkedItemId,
      unreadNotificationsTotalCount,
      areaId,
    ),
  )
}

export function* updateNotificationsForArea({
  notificatedEntities = {},
  notificationAreaName,
}: {
  notificatedEntities: any
  notificationAreaName: string
}) {
  yield updateNotificationsAndTotalCountsForArea({
    notificatedEntities,
    notificationAreaName,
  })
}
